<dp-header class="d-block mb-5" [title]="title" [switch]="switch" [rightActions]="rightActions"></dp-header>
<dp-section-form [form]="sectionForm" (submitted)="submitForm($event)"></dp-section-form>
<div class="row m-0">
    @if (isAdminUser) {
        <div class=" col-12 p-0">
            <app-index-services-header [indexServices]="selectedIndexServices">
            </app-index-services-header>
            <div class="d-flex">
                <app-index-services-table (selectedRow)="onCheckChange()" (tableLoaded)="onTableLoaded($event)"
                    class="col-12">
                </app-index-services-table>
            </div>
        </div>
    }
</div>
